import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const OtherAuth = ({
  isLoginMode,
  showOtherLoginWays,
  setShowOtherLoginWays,
  handleGoogleSignUp,
  handleEmailAuthClick,
  handleSchoolClick,
  loading,
  googleLoading,
}) => {
  return (
    <div className="w-full mt-2">
      {/* Other ways to log in / register Toggle Button */}
      <div className="text-center">
        <button
          type="button"
          onClick={() => setShowOtherLoginWays((prev) => !prev)}
          className="inline-flex items-center justify-center gap-2 px-4 py-2 text-xs md:text-sm font-semibold text-gray-500 hover:text-gray-800 bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-full transition-all duration-200 shadow-sm focus:outline-none cursor-pointer"
        >
          <span>{isLoginMode ? "Other ways to log in" : "Other ways to register"}</span>
          <svg
            className={`w-3.5 h-3.5 text-gray-400 transition-transform duration-300 ${
              showOtherLoginWays ? "rotate-180" : ""
            }`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2.5}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      </div>

      {/* Expandable Google & Email Sign-Up Options */}
      <AnimatePresence initial={false}>
        {showOtherLoginWays && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <div className="pt-3 pb-1 flex flex-col items-center justify-center gap-3 w-full">
              <div className="flex flex-wrap items-center justify-center gap-2.5 w-full">
                {/* Continue with Google */}
                <button
                  type="button"
                  onClick={handleGoogleSignUp}
                  disabled={loading || googleLoading}
                  className="flex-1 min-w-[200px] max-w-full flex items-center justify-center gap-2.5 bg-white hover:bg-gray-50 text-gray-700 font-bold py-2.5 px-3.5 rounded-xl border border-gray-200 shadow-sm transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed text-xs sm:text-sm whitespace-nowrap cursor-pointer"
                >
                  {googleLoading ? (
                    <span>Connecting...</span>
                  ) : (
                    <>
                      <svg className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" viewBox="0 0 24 24">
                        <path
                          fill="#4285F4"
                          d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                        />
                        <path
                          fill="#34A853"
                          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                        />
                        <path
                          fill="#FBBC05"
                          d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"
                        />
                        <path
                          fill="#EA4335"
                          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                        />
                      </svg>
                      <span>Continue with Google</span>
                    </>
                  )}
                </button>

                {/* Continue with Email */}
                {/* <button
                  type="button"
                  onClick={handleEmailAuthClick}
                  disabled={loading || googleLoading}
                  className="flex-1 min-w-[200px] max-w-full flex items-center justify-center gap-2.5 bg-white hover:bg-gray-50 text-gray-700 font-bold py-2.5 px-3.5 rounded-xl border border-gray-200 shadow-sm transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed text-xs sm:text-sm whitespace-nowrap cursor-pointer"
                >
                  <svg
                    className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0 text-gray-700"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={1.8}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                    />
                  </svg>
                  <span>Continue with Email</span>
                </button> */}
              </div>

              {/* School Link */}
              <button
                type="button"
                onClick={handleSchoolClick}
                className="text-[#009DFF] hover:underline text-sm font-bold block mx-auto transition duration-200 mt-2 cursor-pointer"
              >
                {isLoginMode ? "Are you a School? Sign in here" : "Are you a School? Register here"}
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default OtherAuth;
